// @flow
import * as React from 'react';

import useGetLeadContextValues from './useGetLeadContextValues';
import type { OnSubmitMapValues } from '../types';

export type Config<Values: {}> = {|
  onSubmitMapValues: void | OnSubmitMapValues<Values>,
  handleSubmitMapValues: OnSubmitMapValues<Values>,
|};

export default function useHandleOnSubmitMapValues<Values: {}>({
  onSubmitMapValues,
  handleSubmitMapValues,
}: Config<Values>): OnSubmitMapValues<Values> {
  const getLeadContextValues = useGetLeadContextValues();
  return React.useCallback(
    async values => {
      const [maybeValues, mappedValues, leadContextValues] = await Promise.all([
        onSubmitMapValues ? onSubmitMapValues(values) : undefined,
        handleSubmitMapValues(values),
        getLeadContextValues(values),
      ]);

      return {
        subscribe: {
          ...mappedValues.subscribe,
          ...maybeValues?.subscribe,
        },
        createLead: {
          ...leadContextValues,
          ...mappedValues.createLead,
          ...maybeValues?.createLead,
        },
      };
    },
    [onSubmitMapValues, handleSubmitMapValues, getLeadContextValues],
  );
}
